var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOtherIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 15.977a1.312 1.312 0 102.624 0 1.312 1.312 0 00-2.624 0zm6.563 0a1.312 1.312 0 102.624 0 1.312 1.312 0 00-2.625 0zm6.562 0a1.312 1.312 0 102.625 0 1.312 1.312 0 00-2.625 0z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/other-industry.19b1106320f0b944ab56db80daa0753b.svg";
export { SvgOtherIndustry as ReactComponent };